// extracted by mini-css-extract-plugin
export var component = "WastePickupSearchResults-module--component--pCdRC";
export var empty = "WastePickupSearchResults-module--empty--Nj4+e";
export var list = "WastePickupSearchResults-module--list--wnGj2";